import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../config';

const baseUrl = config.baseUrl;
const orgEndpointInsert = '/api/getParticipantePorTecnico';

const api = axios.create({
    baseURL: config.baseUrl,
});

api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
export const obtenerParticipantesPorTecnico = async (email) => {
    try {
        const response = await axios.post(
            `${baseUrl}${orgEndpointInsert}`,
            { email }, // Cuerpo de la solicitud con el email
            {
                headers: {
                    'Content-Type': 'application/json', // Encabezado JSON para enviar datos correctamente
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error al crear la encuesta:', error);
        throw error;
    }
};

  export default obtenerParticipantesPorTecnico;